import React from 'react';
import { Card } from 'react-bootstrap';
import ArticleStatusBadge from './ArticleStatusBadge';

function highlight(text, query) {
  if (!query || !text) return text;
  const esc = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = text.split(new RegExp(`(${esc})`, 'gi'));
  return parts.map((p, i) =>
    p.toLowerCase() === query.toLowerCase()
      ? <mark key={i} style={{ background: '#fff3e0', color: '#a04020', borderRadius: '2px', padding: '0 1px' }}>{p}</mark>
      : p
  );
}

const ArticleCard = ({ article, onClick, searchQuery }) => {
  return (
    <Card
      className="h-100 border"
      style={{ cursor: 'pointer', transition: 'all 0.15s' }}
      onClick={() => onClick(article)}
      onMouseEnter={e => {
        e.currentTarget.style.borderColor = '#e85d04';
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 4px 18px rgba(232,93,4,0.09)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = '#dee2e6';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <Card.Body className="d-flex flex-column">
        <div className="mb-2 d-flex justify-content-between align-items-start gap-2">
          <small className="text-muted">
            {article.category_icon} {article.category}
          </small>
          <ArticleStatusBadge status={article.status} />
        </div>
        <Card.Title style={{ fontSize: '14px', fontWeight: 600, lineHeight: 1.4 }}>
          {highlight(article.title, searchQuery)}
        </Card.Title>
        {article.subtitle && (
          <Card.Text className="text-muted" style={{ fontSize: '12px', lineHeight: 1.5 }}>
            {highlight(
              article.subtitle.length > 100
                ? article.subtitle.slice(0, 100) + '…'
                : article.subtitle,
              searchQuery
            )}
          </Card.Text>
        )}
        <div className="mt-auto">
          {/* #a04020 (~5.8:1 on white) — brand #e85d04 is ~3.95:1, fails AA at this size. */}
          <small style={{ color: '#a04020', fontWeight: 600 }}>Read more →</small>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ArticleCard;
